export default __webpack_public_path__ + "static/media/pdf.29f21e1b.svg";